import React from 'react';
import { map, filter } from 'lodash';
import { ContentApi } from '@model/iceberg';
import { PageTemplates } from '@model/content';
import { GenericHelpPageLayout, GenericHelpPageLayoutProps } from '@layout/GenericHelpPageLayout/GenericHelpPageLayout';
import { getServerSidePropsHelp } from '@layout/get-page-props';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { GetStaticProps } from 'next';
import { Page } from '@model/common';
import { isPageBlacklisted } from '@model/config/brands';
import { Revalidate } from '@model/config/revalidate';

/* ********************* *
 *    GenericHelpPage    *
 * ********************* */
const GenericHelpPage = (props: GenericHelpPageLayoutProps) => {
  return <GenericHelpPageLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ params }: any) => {
  const pageId: string = params.pageId;
  const path: string = Page.HELP.concat('/').concat(params.pageId);
  const props = await getServerSidePropsHelp({ store, pageId, path });

  return {
    ...props,
    revalidate: Revalidate.HALF_HOUR
  };
});

export async function getStaticPaths() {
  const pageConfigMap = await new ContentApi().getPageConfigMap({ template: PageTemplates.INFORMATION });

  const infoPages = filter(
    pageConfigMap,
    ({ path }) =>
      `/${path}`.startsWith(Page.HELP) && path.split('/').length === 2 && !isPageBlacklisted(path.split('/')[1])
  );

  const paths = map(infoPages, ({ path }) => `/${path}`);

  return { paths, fallback: false };
}

export default withGlobalProvider(GenericHelpPage);
